import { useEffectOnce } from 'react-use';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { QuestPromocode } from '../QuestPromocode';
import { generateDescription } from './QuestPromocodes.model';
import {
	StyledContainer,
	StyledEmptyContainer,
} from './QuestPromocodes.styled';

const QuestPromocodes = () => {
	const promocodes = useObservable(rage.promo.getPromoCodes());

	const fetchPromoCodes = () => {
		rage.promo
			.fetchPromoCodes()
			.catch((err) => rage.notifications.showException(err));
	};

	useEffectOnce(() => {
		fetchPromoCodes();

		const interval = setInterval(() => fetchPromoCodes(), 60_000);

		return () => {
			clearInterval(interval);
		};
	});

	if (promocodes.length === 0) {
		return (
			<StyledEmptyContainer>
				<Text>
					К сожалению,
					<br />
					доступных промокодов нет
				</Text>
			</StyledEmptyContainer>
		);
	}

	return (
		<StyledContainer tabIndex={-1}>
			{promocodes.map((value, index) => {
				const isCompleted =
					value.playTimePassedMin >= value.playTimeRequiredMin;
				return (
					<QuestPromocode
						name={value.code}
						description={generateDescription(
							value.playTimePassedMin * 60,
							value.playTimeRequiredMin * 60,
						)}
						code={value.code}
						complete={isCompleted && !value.isClaimed}
						currentTime={value.playTimePassedMin * 60}
						targetTime={value.playTimeRequiredMin * 60}
						rewards={value.rewards}
						key={index}
					/>
				);
			})}
		</StyledContainer>
	);
};

export { QuestPromocodes };
